const translations = {
  "home": { fr: "Accueil", en: "Home" },
  "my_tickets": { fr: "Mes Tickets", en: "My Tickets" },
  "all_tickets": { fr: "Tous les Tickets", en: "All Tickets" },
  "browse_hashtags": { fr: "Explorer par Hashtag", en: "Browse by Hashtag" },
  "knowledge_base": { fr: "Base de Savoir", en: "Knowledge Base" },
  "dashboard": { fr: "Tableau de Bord", en: "Dashboard" },
  "settings": { fr: "Paramètres", en: "Settings" },
  "user_management": { fr: "Gestion Utilisateurs", en: "User Management" },
  "support_control": { fr: "Centre de Contrôle", en: "Control Center" },
  "logout": { fr: "Déconnexion", en: "Logout" },
  "open": { fr: "Ouvert", en: "Open" },
  "in_progress": { fr: "En cours", en: "In Progress" },
  "resolved": { fr: "Résolu", en: "Resolved" },
  "closed": { fr: "Fermé", en: "Closed" },
  "Support Technique": { fr: "Support Technique", en: "Technical Support" },
  "RH / Administratif": { fr: "RH / Administratif", en: "HR / Administrative" },
  "Formation / Tutorat": { fr: "Formation / Tutorat", en: "Training / Tutoring" },
  "total_tickets": { fr: "Total Tickets", en: "Total Tickets" },
  "in_progress_tickets": { fr: "En cours", en: "In Progress" },
  "resolved_tickets": { fr: "Résolus", en: "Resolved" },
  "closed_tickets": { fr: "Fermés", en: "Closed" },
  "create_ticket": { fr: "Créer un Ticket", en: "Create Ticket" },
  "submit": { fr: "Soumettre", en: "Submit" },
  "cancel": { fr: "Annuler", en: "Cancel" },
  "save": { fr: "Enregistrer", en: "Save" },
  "delete": { fr: "Supprimer", en: "Delete" },
  "reply": { fr: "Répondre", en: "Reply" },
  "search": { fr: "Rechercher...", en: "Search..." },
  "title": { fr: "Titre", en: "Title" },
  "description": { fr: "Description", en: "Description" },
  "category": { fr: "Catégorie", en: "Category" },
  "status": { fr: "Statut", en: "Status" },
  "assigned_to": { fr: "Assigné à", en: "Assigned to" },
  "hashtags": { fr: "Hashtags", en: "Hashtags" },
  "attachments": { fr: "Pièces jointes", en: "Attachments" },
  "created_by": { fr: "Créé par", en: "Created by" },
  "created_at": { fr: "Créé le", en: "Created on" },
  "login": { fr: "Connexion", en: "Login" },
  "email": { fr: "Adresse email", en: "Email address" },
  "password": { fr: "Mot de passe", en: "Password" },
  "remember_me": { fr: "Se souvenir de moi", en: "Remember me" },
  "login_btn": { fr: "Se connecter", en: "Sign in" },
  "login_error": { fr: "Email ou mot de passe invalide", en: "Invalid email or password" },
  "demo_accounts_title": { fr: "Comptes de démonstration", en: "Demo accounts" },
  "no_tickets": { fr: "Aucun ticket trouvé", en: "No tickets found" },
  "loading": { fr: "Chargement...", en: "Loading..." },
  "notifications": { fr: "Notifications", en: "Notifications" },
  "mark_all_read": { fr: "Tout marquer comme lu", en: "Mark all as read" },
  "no_notifications": { fr: "Aucune notification", en: "No notifications" },
  "translation_preview": { fr: "Aperçu traduction", en: "Translation preview" },
  "pinned": { fr: "Épinglé", en: "Pinned" },
  "pin": { fr: "Épingler", en: "Pin" },
  "unpin": { fr: "Désépingler", en: "Unpin" },
  "articles": { fr: "articles", en: "articles" },
  "filter_by_category": { fr: "Filtrer par catégorie", en: "Filter by category" },
  "all_categories": { fr: "Toutes les catégories", en: "All categories" },
  "tickets_by_status": { fr: "Tickets par statut", en: "Tickets by status" },
  "tickets_by_category": { fr: "Tickets par catégorie", en: "Tickets by category" },
  "tickets_per_week": { fr: "Tickets par semaine", en: "Tickets per week" },
  "consultant_workload": { fr: "Charge de travail", en: "Workload" },
  "top_hashtags": { fr: "Top Hashtags", en: "Top Hashtags" },
  "kb_articles_count": { fr: "Articles Base de Savoir", en: "Knowledge Base Articles" },
  "open_tickets": { fr: "Tickets ouverts", en: "Open tickets" },
  "role": { fr: "Rôle", en: "Role" },
  "member": { fr: "Membre", en: "Member" },
  "consultant": { fr: "Consultant", en: "Consultant" },
  "dr": { fr: "DR", en: "DR" },
  "dn": { fr: "DN", en: "DN" },
  "direction": { fr: "Direction APOLLO", en: "Direction APOLLO" },
  "support": { fr: "Support APOLLO", en: "Support APOLLO" },
  "select_assignee": { fr: "Sélectionner un responsable", en: "Select assignee" },
  "add_hashtag": { fr: "Ajouter un hashtag...", en: "Add a hashtag..." },
  "write_reply": { fr: "Écrire une réponse...", en: "Write a reply..." },
  "translating": { fr: "Traduction en cours...", en: "Translating..." },
  // Visibility
  "private": { fr: "Privé", en: "Private" },
  "pending_public": { fr: "Validation en cours", en: "Pending Validation" },
  "public": { fr: "Public", en: "Public" },
  "visibility": { fr: "Visibilité", en: "Visibility" },
  "all": { fr: "Tous", en: "All" },
  "request_public": { fr: "Proposer comme ticket Public (soumis à validation Support)", en: "Suggest as Public ticket (requires Support validation)" },
  "request_public_info": { fr: "Ce ticket sera soumis à l'équipe Support APOLLO pour validation. S'il est approuvé, il sera visible par tous les utilisateurs et ajouté à la Base de Savoir.", en: "This ticket will be submitted to the Support APOLLO team for validation. If approved, it will be visible to all users and added to the Knowledge Base." },
  "validate_public_banner": { fr: "Ce ticket a été proposé comme Public. Voulez-vous le valider ?", en: "This ticket was suggested as Public. Do you want to validate it?" },
  "validate_as_public": { fr: "Valider comme Public", en: "Validate as Public" },
  "keep_private": { fr: "Garder Privé", en: "Keep Private" },
  // Scope labels
  "scope_member": { fr: "Mes Tickets", en: "My Tickets" },
  "scope_consultant": { fr: "Tickets de mon Groupe", en: "My Group Tickets" },
  "scope_dr": { fr: "Tickets de ma Région", en: "My Region Tickets" },
  "scope_dn": { fr: "Tickets Nationaux", en: "National Tickets" },
  "scope_direction": { fr: "Tous les Tickets APOLLO", en: "All APOLLO Tickets" },
  "scope_support": { fr: "Tous les Tickets APOLLO", en: "All APOLLO Tickets" },
  // Ticket locking (status-based reply rules)
  "lock_closed_banner": { fr: "🔒 Ce ticket est fermé — consultation uniquement", en: "🔒 This ticket is closed — read-only" },
  "lock_resolved_banner": { fr: "🔒 Ce ticket est résolu — seul le créateur peut répondre pour relancer la conversation", en: "🔒 This ticket is resolved — only the creator can reply to reopen the conversation" },
  "lock_creator_hint": { fr: "ℹ️ Votre réponse rouvrira la conversation", en: "ℹ️ Your reply will reopen the conversation" },
  "reopen_toast": { fr: "Ticket rouvert — les réponses sont à nouveau possibles", en: "Ticket reopened — replies are now possible again" },
  "reopen_denied": { fr: "Seul Support ou Direction peut rouvrir un ticket fermé", en: "Only Support or Direction can reopen a closed ticket" },
  // Signature toggle (Direction/Support peuvent signer "Support APOLLO" sans changer de compte)
  "post_as_label": { fr: "Répondre en tant que :", en: "Reply as:" },
  "post_as_self": { fr: "Moi-même", en: "Myself" },
  "post_as_support": { fr: "Support APOLLO", en: "Support APOLLO" },
  "signed_as_support": { fr: "Signé Support APOLLO", en: "Signed as Support APOLLO" },
};

export function t(key, lang) {
  if (!lang) lang = 'fr';
  var entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry.fr || key;
}

export default translations;
